import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
} from "reactstrap";
import { useEffect, useRef, useState, startTransition } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import Header from "components/Headers/Header";
import { FcSupport } from "react-icons/fc";

// Hook personalizado para intervalos seguros
const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay !== null) {
      const id = setInterval(() => savedCallback.current(), delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

const EquiposIntaladosInspec = (props) => {
  const [list1, setList1] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);

  const urlendpoint =
    "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerEquipoInstalado/" +
    props.OrdenId;

  const fetchData = () => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: urlendpoint,
    })
      .then((response) => {
        setList1(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error al obtener equipos:", error);
      });
  };

  // Ejecuta fetchData solo cuando el modal está abierto
  useEffect(() => {
    if (modalIsOpen) fetchData();
  }, [modalIsOpen]);

  useInterval(
    () => {
      if (modalIsOpen) fetchData();
    },
    modalIsOpen ? 6000 : null,
  );

  const handleOpenModalTest = () => {
    startTransition(() => setIsOpen(true));
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        className="btn btn-yellow btn-lg"
        onClick={handleOpenModalTest}
        title="Equipos Montados"
        style={{ border: "2px solid #0085CA" }}
      >
        <FcSupport style={{ marginRight: "0px" }} />
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Equipos Instalados"
        ariaHideApp={false}
        style={{
          content: {
            inset: "40px",
            padding: "0",
            border: "none",
            borderRadius: "8px",
            overflow: "hidden",
          },
        }}
      >
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h3 className="mb-0">Equipos Instalados</h3>
                </CardHeader>

                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Id</th>
                      <th scope="col">Nombre</th>
                      <th scope="col">Serial</th>
                      <th scope="col">Capacidad</th>
                      <th scope="col">Fecha Fabricación</th>
                      <th scope="col">Fecha Prox. Prueba</th>
                      <th scope="col">Fecha Ultima Prueba</th>
                      <th scope="col">Fecha Instalación</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list1.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.nombreEquipo}</td>
                        <td>{item.serial}</td>
                        <td>{item.capacidad}</td>
                        <td>{item.fechaFabricacion}</td>
                        <td>{item.prueba}</td>
                        <td>{item.ultimaPrueba}</td>
                        <td>{item.fechaInstalacion}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination
                      className="pagination justify-content-end mb-0"
                      listClassName="justify-content-end mb-0"
                    >
                      <PaginationItem className="disabled">
                        <PaginationLink
                          href="#"
                          onClick={(e) => e.preventDefault()}
                          tabIndex="-1"
                        >
                          <i className="fas fa-angle-left" />
                          <span className="sr-only">Anterior</span>
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem className="active">
                        <PaginationLink
                          href="#"
                          onClick={(e) => e.preventDefault()}
                        >
                          1
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          href="#"
                          onClick={(e) => e.preventDefault()}
                        >
                          2
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          href="#"
                          onClick={(e) => e.preventDefault()}
                        >
                          3
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          href="#"
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fas fa-angle-right" />
                          <span className="sr-only">Siguiente</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default EquiposIntaladosInspec;
